
import {Component, Vue, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";
import RestrictionDialog from "@/components/RestrictionDialog.vue";
import {TranslateResult} from "vue-i18n";

@Component({
    components: {
        RestrictionDialog,
    },
})
export default class KeyArchive extends Vue {

    get isArchived(): boolean {
        return this.currentKey.status === "ARCHIVED";
    }

    get isArchiveActionDisable(): boolean {
        return !(this.canArchive || this.canUnarchive);
    }

    get canArchive(): boolean {
        const canBeArchived: boolean = !this.isArchived
            && !["IN_RELAY", "IN_TRANSIT"].includes(this.currentKey.status);
        return canBeArchived && this.canDoInEnvCompany("ARCHIVE_KEY");
    }

    get canUnarchive(): boolean {
        return this.isArchived && this.canDoInEnvCompany("UNARCHIVE_KEY");
    }

    get dialogText() {
        if (!this.isArchived) {
            return {
                button: "actions.archive",
                title: "key.archive.title",
                confirmation: "key.archive.confirmation",
                success: "alerts.key.archiveSuccess",
            };
        }
        return {
            button: "actions.unarchive",
            title: "key.unarchive.title",
            confirmation: "key.unarchive.confirmation",
            success: "alerts.key.unarchiveSuccess",
        };
    }

    get ruleMessage(): TranslateResult {
        return this.isArchived && !this.canUnarchive
            ? this.$t("key.unarchive.rule")
            : this.$t("key.archive.rule");
    }

    @Getter private currentUser: any;
    @Getter private isMobile: boolean;
    @Getter private canDoInEnvCompany: (right: string) => boolean;

    @Prop({default: null})
    private currentKey: any;

    private showDialog: boolean = false;
    private disableKeyArchive: boolean = false;
    private isRestrictedOn: string = null;
    private loading: boolean = false;

    private mounted() {
        this.disableKeyArchive = !this.canDoInEnvCompany("ARCHIVE_KEY");
    }

    private archiveKey() {
        this.loading = true;
        this.$store.dispatch("keys/archive", {
          keyId: this.currentKey.id,
        }).then(() => {
            const successMsg = this.isArchived ? "alerts.key.archiveSuccess" : "alerts.key.unarchiveSuccess";
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t(successMsg, {key: this.currentKey.name}),
            });
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: this.$i18n?.t(`alerts.error.${err.response.data.error}`),
            });
        }).finally(() => {
          this.archiveKeyDone();
        });
    }

    private archiveKeyDone(): void {
        this.$store.dispatch("context/clearContext");
        this.$emit("reset");
        this.close();
    }

    private close(): void {
        this.showDialog = false;
        this.loading = false;
    }
}
